import { Dispatch, SetStateAction } from 'react';
import { DispatchMetrics } from '@catalogo/core-metrics';

export const closureHandleVisible = (
  visible: boolean,
  setVisible: Dispatch<SetStateAction<boolean>>,
  dispatchMetrics: DispatchMetrics,
  metricId?: string,
  metricCategory?: string,
  metricAction?: string
) => () => {
  setVisible(!visible);
  if (metricId) {
    dispatchMetrics('event:track', {
      category: metricCategory ?? 'accordion',
      action: metricAction ?? `click-${visible ? 'close' : 'open'}`,
      label: metricId,
    });
  }
};

export const closureHandleExpand = (
  setExpandedContent: Dispatch<SetStateAction<boolean>>,
  dispatchMetrics: DispatchMetrics
) => () => {
  setExpandedContent(true);
  dispatchMetrics('event:track', {
    category: 'accordion',
    action: 'click',
    label: 'ver mais',
  });
};
